import IEventObserver from "./IEventObserver";

class EventsObservable {

    private _observers;

    constructor() {
        this._observers = {};
    }

    subscribe(type: string|string[], observer: IEventObserver|Function) {

        if(typeof type === "string") {
            type = [type];
        }

        for(let t of type) {

            if(!this._observers[t]) {
                this._observers[t] = [];
            }

            this._observers[t].push(observer);
        }
    }

    unsubscribe(type, observer) {
        this._observers[type] = this._observers[type].filter(o => o !== observer);
    }

    async dispatch(eventName:string, data?:any, prevData?:any) {

        if(!this._observers[eventName]) return;
        // if(!this._checkEvent(eventName)) return;

        for(let observer of this._observers[eventName]) {
            await this._notify(observer, eventName, data, prevData);
        }

    }

    dispatchSync(eventName:string, data?:any, prevData?:any) {

        if(!this._observers[eventName]) return;

        for(let i = 0, l = this._observers[eventName].length; i < l; i++) {
            this._notify(this._observers[eventName][i], eventName, data, prevData);
        }
    }

    dispatchAll(eventName:string, data?:any, prevData?:any) {

        // this._checkEvent(eventName);

        if(!this._observers[eventName] || !this._observers[eventName].length) {

            return Promise.resolve();

        } else if(this._observers[eventName].length === 1) {

            return this._notify(this._observers[eventName][0], eventName, data, prevData);

        } else {

            let events = [];

            for(let observer of this._observers[eventName]) {
                events.push(this._notify(observer, eventName, data, prevData));
            }

            return Promise.all(events);
        }
    }

    // async dispatchAsyncEach(eventName, data = {}) {
    //
    //     for (let event of this._observers[eventName]) {
    //         await this._notify(event, eventName, data);
    //     }
    //
    // }

    // _checkEvent(eventName) {
    //     if(!this._observers[eventName]) {
    //         console.warn("Event " + eventName + " not subscribed");
    //         return false;
    //     }
    //
    //     return true;
    // }

    _notify(observer, eventName, data, prevData = null) {
        if(typeof observer === "function") {
            return observer.call(observer, eventName, data, prevData);
        } else {
            return observer.notify.call(observer, eventName, data, prevData);
        }
    }
}

const eventsObservable = new EventsObservable();

export default eventsObservable;

// export function dispatch(eventName, data) {
//     return eventsObservable.dispatch(eventName, data);
// }
//
// export function subscribe(types = [], event) {
//
// }